import { createSelector } from "reselect"
import { ContextualHelpDictionary, ContextualHelpTerm } from "../../models"
import { IContextualHelp } from "./index"

const getDictionarySources = (
    state: IContextualHelp,
): ContextualHelpDictionary[] => state.dictionaries

const getTermsFilter = (state: IContextualHelp): string =>
    state.dictionaryPopup.termsFilter

export const getAllDictionaryTerms = createSelector(
    [getDictionarySources],
    (dictionarySources): ContextualHelpTerm[] =>
        dictionarySources.flatMap((dictionarySource) => dictionarySource.terms),
)

export const getSortedDictionaryTerms = createSelector(
    [getAllDictionaryTerms],
    (terms): ContextualHelpTerm[] =>
        terms.sort((term1, term2) => term1.label.localeCompare(term2.label)),
)

export const getFilteredTerms = createSelector(
    [getSortedDictionaryTerms, getTermsFilter],
    (terms, filter): ContextualHelpTerm[] =>
        terms.filter((term) =>
            term.label.toLowerCase().includes(filter.toLowerCase()),
        ),
)

const getTermCode = (_state: IContextualHelp, termCode: string): string =>
    termCode

export const getTerm = createSelector(
    [getAllDictionaryTerms, getTermCode],
    (allTerms, termCode): ContextualHelpTerm | undefined =>
        allTerms.find((term) => term.code === termCode),
)
